import React, { useState } from 'react'
import { 
  Modal, 
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Col
} from 'reactstrap'
import _ from 'lodash'

import LoadingOverlay from 'components/Indicator/LoadingOverlay'

const Create = ({
  showCreateRole,
  newRole,
  onChangeRolesHOC,
  createRole
}) => {

  const onChangeRoleData = ( key, val ) => {
    let tmp = _.cloneDeep( newRole )
    tmp[ key ] = val
    return onChangeRolesHOC( 'newRole', tmp )
  }

  return (
    <Modal
      isOpen={ showCreateRole }
      size={ 'xl' }
      toggle={() => {
        onChangeRolesHOC( 'showCreateRole', false )
      }}>
      <ModalHeader toggle={() => onChangeRolesHOC( 'showCreateRole', false )}>Create role</ModalHeader>
      <ModalBody>
        <Form onSubmit={ e => e.preventDefault()}>
          <FormGroup>
            <Label>Name</Label>
            <Input
              type="text"
              value={ newRole.name }
              onChange={ e => {
                onChangeRoleData( 'name', e.target.value )
              }} />
          </FormGroup>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button 
          color="primary"
          onClick={() => {
            createRole( newRole )
          }}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default Create